(ns tubax.saxjs
  (:require ["sax" :as sax]))

(goog/exportSymbol "sax" sax)
